/** Photos the slide track passes on its way from one photo to another, both ends included. */
export const getCrossedUrls = (images: string[], fromIndex: number, toIndex: number) =>
  images.slice(Math.min(fromIndex, toIndex), Math.max(fromIndex, toIndex) + 1);
